module.exports = __webpack_public_path__ + "static/media/reset_success.2f16083a.svg";